/**
 * TaskProgressSummary Constants
 *
 * Centralized constants for progress summary component to avoid magic numbers
 * and ensure consistency across the component.
 */

/**
 * Icon size for progress item headers (pixels)
 * Used for IconChecklist and IconLink icons
 */
export const PROGRESS_ICON_SIZE = 18;

/**
 * Progress bar color when task is in progress (< 100%)
 * Uses Mantine theme color
 */
export const PROGRESS_COLOR_ACTIVE = 'indigo';

/**
 * Progress bar color when task is complete (100%)
 * Uses Mantine theme color
 */
export const PROGRESS_COLOR_COMPLETE = 'green';

/**
 * Chevron icon size for navigation indicator (pixels)
 * Shows that clicking the row navigates to the respective tab
 */
export const CHEVRON_ICON_SIZE = 16;
